import React, { useEffect, useState } from 'react';

import DOMPurify from 'dompurify';

import Document from 'components/Document';
import Loader from 'components/Loader';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useAppNavigate from 'hooks/useAppNavigate';
import { AppRoutes } from 'routes/routes.enums';
import { useAppSelector } from 'hooks/useAppSelector';
import { IntermediaryApplicationProps } from 'api/IntermediaryApplicationsApi';
import { documentsApi } from 'api/DocumentsApi';

const MasterDealerAgreement = () => {
  const navigator = useAppNavigate();
  const dispatch = useAppDispatch();
  const contractorApplication = useAppSelector(
    (state) => state.contractorPortal.contractorApplication as IntermediaryApplicationProps,
  );
  const [masterDealerAgreementDocument, setMasterDealerAgreementDocument] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!contractorApplication) {
      return navigator(AppRoutes.ContractorPortal);
    }

    const getMasterDealerAgreementDocument = async () => {
      const masterDealerAgreementResponse = await documentsApi.downloadMasterDealerAgreement({
        federalTaxId: contractorApplication.intermediary_federal_tax_id,
        legalBusinessName: contractorApplication.intermediary_business_name,
        entityStructure: contractorApplication.intermediary_business_entity_structure,
        mainContactFirstName: contractorApplication.intermediary_main_contact_first_name,
        mainContactLastName: contractorApplication.intermediary_main_contact_last_name,
        mainContactPosition: contractorApplication.intermediary_main_contact_position,
        businessAddress: contractorApplication.intermediary_corporate_address_information,
        phone: contractorApplication.intermediary_phone,
        email: contractorApplication.intermediary_email,
        signerFirstName: contractorApplication.intermediary_authorized_signer_first_name,
        signerLastName: contractorApplication.intermediary_authorized_signer_last_name,
        whoSignedMasterDealerAgreement: contractorApplication.intermediary_who_signed_master_dealer_agreement,
      });

      setMasterDealerAgreementDocument(masterDealerAgreementResponse);
      setLoading(false);
    };

    getMasterDealerAgreementDocument();
  }, [dispatch, contractorApplication]);

  const masterDealerAgreement = (
    <Document title="Master Dealer Agreement" showBackButton>
      <div
        className="content"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(masterDealerAgreementDocument, { FORCE_BODY: true }),
        }}
      ></div>
    </Document>
  );

  return <>{loading ? <Loader /> : masterDealerAgreement}</>;
};

export default MasterDealerAgreement;
